// src/components/Footer.js
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useContext } from 'react';
import ThemeContext from '../context/ThemeContext';
import { useNavigate } from 'react-router-dom';
import Marquee from 'react-fast-marquee';

const RunnerContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: ${({ theme }) => theme.mainField || '#333'};
  color: ${({ theme }) => theme.mainText || '#fff'};
  z-index: 1000;
  height: 21px;
  cursor: pointer;
`;

const Footer = () => {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/version-notes');
  };

  return (
    <RunnerContainer theme={theme} onClick={handleClick}>
      <Marquee gradient={false} speed={21}>
        [version: 1.1      date: 10.24.2024      author: Jack Freedenberg]        
        [version: 1.2      date: 10.29.2024      author: Jack Freedenberg]        
        [version: 1.3      date: 12.2.2024      author: Jack Freedenberg]        
        [version: 1.4      date: 3.10.2025      author: Jack Freedenberg]        
        [version: 1.5      date: 3.22.2025      author: Jack Freedenberg]        
      </Marquee>
    </RunnerContainer>
  );
};

export default Footer;

/* 
  1.1 did all the hard stuff before this. Just added footer and started naming versions. 
  1.2 is a big update. Visually focused on removing generic scroll function and wrapping all content between header and footer. Also added a new customization: me. Ensured proper DNS via netlify and adjusted AWS Lambda to properly recognize new domain. This update also is the start of me recording notes in relation to update releses. 
  1.3 minimal aesthetic update. Added custom favicon and site title with plans for dynamic title in the future. 
  1.4 updated about me and about the site sections. Deprecated contact page. 
  1.5 glass feel to text boxes. 
*/